import type { RoundFeedPage } from "../contracts/round-feed.js";
import type { BootstrapPayload } from "../contracts/bootstrap.js";
import type { ComparisonRelation } from "../../domain/insights/comparison-types.js";

export function clubhouseViewerIds(
  participants: BootstrapPayload["participants"],
  accountId: string,
  relations: ComparisonRelation[],
): string[] {
  const owned = participants
    .filter((person) => person.accountId === accountId)
    .map((person) => person.id);
  if (owned.length) return owned;
  // A team includes other people. It must never identify all teammates as the viewer.
  return [
    ...new Set(
      relations.flatMap((relation) => {
        const party = relation[relation.viewerSide];
        return party.kind === "person" ? party.memberIds : [];
      }),
    ),
  ];
}

/** Keep days chronological; within a day, discover rivals' rounds before your own. */
export function prioritizeClubhouseRounds(
  items: RoundFeedPage["items"],
  viewerIds: string[],
): RoundFeedPage["items"] {
  const own = (item: (typeof items)[number]) =>
    Number(
      item.card.sides.some((side) =>
        side.participantIds.some((id) => viewerIds.includes(id)),
      ),
    );
  return [...items].sort((a, b) => {
    const dayA = a.card.date?.slice(0, 10) ?? "";
    const dayB = b.card.date?.slice(0, 10) ?? "";
    return (
      dayB.localeCompare(dayA) ||
      (dayA ? own(a) - own(b) : 0) ||
      (b.card.date ?? "").localeCompare(a.card.date ?? "")
    );
  });
}
